import TileLayer from 'ol/layer/tile'
import XYZSource from 'ol/source/xyz'
import './Base';
import '../../../Format';

/** @namespace GIS.Map.Layer.OL3 */
NS("GIS.Map.Layer.OL3");

/**
 * @class
 * @extends GIS.Map.Layer.OL3.Base
 */
GIS.Map.Layer.OL3.Tile = Class(GIS.Map.Layer.OL3.Base, /** @lends GIS.Map.Layer.OL3.Tile.prototype */{
    // options
    url: null,
    wrapX: true,
    preload: 0,
    tilePixelRatio: 1,
    tileSize: [256, 256],
    format: GIS.Format.PNG,
    tileFormat: GIS.Format.extension(GIS.Format.PNG),
    layerName: null,
    crossOrigin: "anonymous",
    /** @type {string[]} Additional url tokens */
    urlParams: ["layerName", "tileFormat"],
    /**
     * @type {ol.source.XYZ}
     * @protected
     */
    source: null,
    /**
     * @type {ol.layer.Tile}
     * @protected
     */
    layer: null,
    /**
     * @type {GIS.Map.Layer.Tile}
     * @protected
     */
    base: null,
    /** @inheritDoc */
    optionsNames()
    {
        return this.ParentCall().concat(["url", "wrapX", "preload", "tileSize", "tileFormat", "tileGrid", "format", "tilePixelRatio",
                                         "crossOrigin", "tileUrlFunction", "urlParams"]);
    },
    /**
     * @param {Object} [options]
     * @protected
     */
    prepareOptions(options = {})
    {
        options = this.Parent(options);

        if (options.format != null) {
            options.tileFormat = GIS.Format.extension(options.format);
        }

        if (options.tileSize != null && !_.isArray(options.tileSize)) {
            options.tileSize = [_.parseInt(options.tileSize)];
        }

        return options;
    },
    /**
     * @param {Object} options
     * @returns {ol.layer.Tile}
     * @protected
     */
    createLayer(options)
    {
        const layerOptions = {
            ...Util.pickOptions(
                options,
                ["opacity", "extent", "minResolution", "maxResolution", "preload"]
            ),
            visible: !!options.visibility,
            source: this.createSource(options)
        };

        if (options.overlay) {
            layerOptions.map = this.map.getVendor();
        }

        return new TileLayer(layerOptions);
    },
    /**
     * @param {Object} options
     * @returns {ol.source.XYZ}
     * @protected
     */
    createSource(options)
    {
        const sourceOptions = Util.pickOptions(options, ["projection", "wrapX", "url", "tileSize", "attributions",
                                                         "tilePixelRatio", "crossOrigin", "tileGrid"]);

        sourceOptions.url = this.Class.prepareURL(sourceOptions.url, options, options.urlParams);
        sourceOptions.tileUrlFunction = this.map.createTileUrlFunction(sourceOptions.url);

        if (!_.isEmpty(sourceOptions.attributions)) {
            sourceOptions.attributions = this.Class.createAttributions(sourceOptions.attributions);
        }

        this.source = new XYZSource(sourceOptions);

        return this.source;
    },
    /** @inheritDoc */
    setVendorProjection(projection)
    {
        // ol3 doesn't exports setProjection method in current version then recreate source of the layer
        if (this.layer) {
            this.layer.setSource(
                this.createSource({
                    ...Util.pickOptions(this, this.optionsNames()),
                    projection
                })
            );
        }
    },
});
